import { useAmplitude } from '@crehana/analytics';
import { BannerTop } from '@crehana/compass.ui';

import { useEffect } from 'react';
import { ApplicationFormStatus } from '../../shared/application-form-status';
import { Details } from '../shared/components/details';
import { Form } from '../shared/components/form';
import { useTranslationCandidateForm } from '../shared/hooks/use-translations';
import type {
  TPageLoaderOrganizationData,
  TPageLoaderVacancyData,
} from '../types';

export const CandidatePreviewForm = ({
  vacancy: jobVacancyPublicInfo,
  organization,
}: {
  vacancy: TPageLoaderVacancyData;
  organization: TPageLoaderOrganizationData;
}) => {
  const { logEvent } = useAmplitude();
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    logEvent({
      event: 'Render Candidate Form',
      data: {
        url: window.location.href,
        product: 'ATS',
      },
    });
  }, []);

  const { t } = useTranslationCandidateForm();

  const organizationId =
    jobVacancyPublicInfo?.centralized_organization_id as number;

  // Display a not found status if the job vacancy is not found
  if (jobVacancyPublicInfo && !jobVacancyPublicInfo.id) {
    return (
      <div className="tw-h-[100vh]">
        <ApplicationFormStatus
          title={t('CANDIDATE_FORM_STATUS_TITLE_NOT_FOUND')}
          description={t('CANDIDATE_FORM_STATUS_DESCRIPTION_NOT_FOUND')}
          type="not-found"
        />
      </div>
    );
  }

  return (
    <div className="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center">
      {/**Show the job vacancy details */}
      <div className="tw-w-full">
        <BannerTop
          open={true}
          type="base"
          text={t('BANNER_PREVIEW_FORM')}
          hideClose
          className="tw-mt-0"
        />
        <Details
          jobVacancyPublicInfo={jobVacancyPublicInfo}
          name={organization.name || ''}
          logo={organization.logo || ''}
        />
      </div>
      {/**Show the application form */}
      <div
        id="application-form"
        className="tw-w-full tw-flex tw-justify-center tw-px-3.2 md:tw-px-[9.2rem] lg:tw-px-[32.4rem] tw-py-3.2 md:tw-py-6.4 lg:tw-py-7.2"
        style={{
          background:
            'linear-gradient(90deg, #F2F3F5 0%, rgba(240, 242, 255, 0.90) 100%)',
        }}
      >
        <Form
          jobVacancyPublicInfo={jobVacancyPublicInfo}
          organizationId={organizationId || 0}
          preview={true}
        />
      </div>
    </div>
  );
};
